<template>
  <!-- popup -->
  <div class="popup">
    <div class="popupContent">
      <!-- 左部分 -->
      <left/>
      <!-- 右部分 -->
      <righy/>
    </div>
  </div>
</template>

<script>
import left from './popupLeft';
import righy from './popupRight';
export default {
  name:'popup',
  data() {
    return {
      
    }
  },
  components:{
    left,
    righy,
  },
  mounted(){
    this.common.popup();
    this.common.popupNone();
    this.common.popupAxios();
    this.common.panduan();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
/* popup */
.popup{
  display: none;
  position: fixed;
  width: 44rem;
  top: 35%;
  left: 50%;
  margin-left: -355px;
  padding: 10px;
  background: #fff;
  border-radius: 30px;
  z-index: 999;
  box-shadow: 0 0 5px #333;
  .popupContent {
    display: flex;
  } 
}
</style>



// WEBPACK FOOTER //
// src/components/Popup/popup.vue